import { Provider } from '@angular/core';

export const serviceProviders: Provider[] = [];
